import React, { useState } from 'react';
import SharedHelmet from '../Helmet';
import MainCalculatorsList from '../MainCalculators';
import RelatedLinks from '../RelatedLinks';
import { CalculatorsType } from '../ConstantsEN';
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = 'Velocity Calculator - Calculate Velocity Based on Distance and Time';
const DESCRIPTION = 'The Velocity Calculator calculates velocity based on distance and time.';
const KEYWORDS = 'Velocity calculation, Velocity calculator, Calculate velocity based on distance and time';
const OG_URL = 'https://do-calculate.com/calculator/en/velocity';
function VelocityCalculator() {
  const [distance, setDistance] = useState('');
  const [time, setTime] = useState('');
  const [velocity, setVelocity] = useState('');
  const [error, setError] = useState('');
  const handleCalculate = () => {
    if (!distance || !time) {
      setError('Please enter distance and time correctly');
      setVelocity('');
      return;
    }
    const distanceValue = parseFloat(distance);
    const timeValue = parseFloat(time);
    if (isNaN(distanceValue) || isNaN(timeValue) || timeValue <= 0) {
      setError('Please enter valid and positive values for distance and time');
      setVelocity('');
      return;
    }
    const velocityValue = distanceValue / timeValue;
    setVelocity(velocityValue.toFixed(2));
    setError('');
  };
  return (
    <div className="ltr">
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL} />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />         </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: '40px' }}>
            <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
          </div>
              <div className="border border-light">
                <div className="row">
                  <div>
                    <p>
                      This calculator helps you calculate velocity based on distance and time. To calculate velocity, enter the distance (in kilometers) and time (in hours).
                    </p>
                    <p>
                      The velocity calculation formula is:
                    </p>
                    <p><b>Velocity (kilometers per hour) = Distance (kilometers) / Time (hours)</b></p>
                    <p>
                      After entering the appropriate values, click the "Calculate Velocity" button to get the result.
                    </p>
                  </div>
                </div>
                 <MobileUnderCalAds/>
                <div className="row">
                  <div className="col-sm-12 col-md-7 calculatorStyle">
                    <div className='p-3 mb-2 bg-success text-white'>
                      <h2 style={{ fontSize: '16px' }}>{TITLE} </h2>
                    </div>
                    <hr />
                    <div dir="ltr">
                      <div>
                        <div className="form-group d-flex align-items-center">
                          <b>
                            <label className="form-label ms-2">Distance (kilometers)</label>
                          </b>
                          <input
                            type="number"
                            placeholder="80"
                            value={distance}
                            onChange={(e) => setDistance(e.target.value)}
                            className="form-control"
                            style={{ width: '150px' }}
                          />
                        </div>
                        <br />
                        <div className="form-group d-flex align-items-center">
                          <b>
                            <label className="form-label ms-2">Time (hours)</label>
                          </b>
                          <input
                            type="number"
                            placeholder="8"
                            value={time}
                            onChange={(e) => setTime(e.target.value)}
                            className="form-control"
                            style={{ width: '150px' }}
                          />
                        </div>
                        <br />
                        <button
                          className="btn btn-success"
                          style={{ fontSize: '20px' }}
                          onClick={handleCalculate}
                        >
                          Calculate Velocity
                        </button>
                      </div>
                      <br />
                      <div>
                        {error !== '' ? (
                          <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
                        ) : (
                          <>
                            {velocity !== '' && (
                              <>
                                <p className='p-3 mb-2 bg-success text-white'>
                                  Velocity (kilometers per hour): {velocity}
                                </p>
                                <p className='p-3 mb-2 bg-info text-black'>
                                  Calculation Steps: <br />
                                  - Calculate velocity based on the following formula:
                                  Velocity (kilometers per hour) = Distance (kilometers) / Time (hours)
                                </p>
                              </>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <RelatedLinks />               </div>
        </div>
        <div className="col">
          <SecondAds />           <br />
          <MainCalculatorsList CalculatorsTypeId={CalculatorsType.physicsCalculators}></MainCalculatorsList>                      <br />
        </div>
      </div>
       <br />
    </div>
  );
}
export default VelocityCalculator;
